import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadAssetsThunk } from '../../store/assets/assetsThunks'
import { AppDispatch, RootState } from '../../store'
import {getStorage} from '../../hooks/useAuth';



const AssetsLoader = () => {
  const dispatch = useDispatch<AppDispatch>()
    const token = getStorage().getItem('access_token');
  const alreadyLoaded = useSelector((state: RootState) => state.assets.loaded)

  useEffect(() => {
    if (token && !alreadyLoaded) {
      dispatch(loadAssetsThunk())
    }
  }, [dispatch, token, alreadyLoaded])

  return null
}

export default AssetsLoader
